import Alert from "react-bootstrap/Alert";
import PropTypes from "prop-types";

import Translated from "../Translated";
import CategorySelector from "../CategorySelector";
import CategoryStart from "../CategoryStart";
import Spinner from "../Spinner";
import ResetVehicleCategoryButton from "../ResetVehicleCategoryButton";
import { useUserData } from "../../../context/UserDataContext";
import AssessmentInstructions from './AssessmentInstructions';
import { getAssessment } from '../../../utils/assessmentUtil';

const FullTestStart = ({ start, locale }) => {
  const { userSettings } = useUserData();

  const renderContent = () => {
    if (!userSettings.data) {
      return <Spinner />;
    }

    const category = userSettings.vehicleCategory;

    if (!category) {
      return <CategorySelector />;
    }

    const settingsData = userSettings.data;
    const categorySettings = settingsData.categorySettings[category.toLowerCase()];
    const isLanguageSupported = categorySettings.langs.indexOf(locale) !== -1;

    if (!isLanguageSupported) {
        return (
            <Alert>
              <Translated translationKey="category_unsupported_lang" />
            </Alert>
        );
    }

    const hasSubCategories = categorySettings.subCategories !== undefined && categorySettings.subCategories.length > 0;

    if (hasSubCategories) {
      return <CategorySelector category={category} categories={categorySettings.subCategories} isSubCategories />;
    }

    return (
        <div id="full-test-start-container">
          <div>
            <h3>
              <Translated translationKey="full_test_title" />
            </h3>
            <Translated translationKey="full_test_description" />
          </div>
          <br />
          <AssessmentInstructions category={category} assessment={getAssessment(settingsData, category)} />
          <CategoryStart
            id="full-test-start"
            category={category}
            start={start}
          />
          <ResetVehicleCategoryButton bsstyle="link" />
        </div>
    );
  };

  return (
    <div id="full-test-start-page" className="max-width-container">
      {renderContent()}
    </div>
  );
};

FullTestStart.propTypes = {
  start: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

export default FullTestStart;
